// Added by Sejune Oh on 2020-03-25
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! Style
import { customStyles } from '@/components/worklist/TaskList'
type ComponentTypes = 'tasklist'

export type TaskListStyleTypes = {
  [key in ComponentTypes]: Record<string, any>
}

export const TaskListStyles: TaskListStyleTypes = {
  tasklist: customStyles
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! Wrapper Component
export { default as TaskListWrapper } from './TaskListWrapper'
export * from './TaskListWrapper'
